import tracking from 'dibs-tracking';

const trackFollowDealer = ({ isMC, action }) =>
    tracking.trackEvent({
        category: 'dealer favoriting',
        label: isMC ? 'message center' : 'pdp',
        action,
    });

const sqrTracking = {
    trackClicked: ({ trackingLocation }) =>
        tracking.trackEvent({
            action: 'contact dealer clicked',
            category: 'contact dealer',
            label: `request a shipping quote - ${trackingLocation}`,
        }),
    trackSend: ({ trackingLocation }) =>
        tracking.trackEvent({
            action: 'contact dealer send clicked',
            category: 'contact dealer',
            label: `request a shipping quote - ${trackingLocation}`,
        }),
    trackSuccess: ({ trackingLocation }) =>
        tracking.trackEvent({
            action: 'contact dealer submitted',
            category: 'contact dealer',
            label: `request a shipping quote - ${trackingLocation}`,
        }),

    trackDealerFollowed: ({ isMC }) => trackFollowDealer({ isMC, action: 'dealer added' }),
    trackDealerUnFollowed: ({ isMC }) => trackFollowDealer({ isMC, action: 'dealer removed' }),
};

export default sqrTracking;
